module.exports = __webpack_public_path__ + "static/img/19017B_4_C_20230527_LC.1d6dfa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19017B_4_C_20230527_LC.png
// module id = z9fz
// module chunks = 0